<template>
  <div>
    <div :id="chartName"
         style="width: 100%; background-color: #FFFFFF;"
         :style="'height: ' + height"></div>
  </div>
</template>
<script>
  import moment from 'moment'
  import randomColor from 'randomcolor'
  import _ from 'lodash'

  require('amcharts3')
  require('amcharts3/amcharts/serial')
  require('amcharts3/amcharts/themes/light')
  require('amcharts3/amcharts/lang/fr')
  export default {
    name: 'RdvsCharts',
    props: {
      entities: {
        type: Array,
        required: true
      },
      entityKey: {
        type: String,
        required: true
      },
      dateParam: {
        type: String,
        default: 'date'
      },
      chartType: {
        type: String,
        default: 'line'
      },
      chartName: {
        type: String,
        default: 'chart'
      },
      height: {
        type: String,
        default: '500px'
      },
      customName: {
        type: Function,
        default (val) {
          return val.name
        }
      },
      period: {
        type: Array,
        default () {
          return []
        }
      }
    },
    watch: {
      entities (v) {
        if (v) {
          this.dirtyInit()
        }
      }
    },
    methods: {
      dirtyInit () {
        let data = this.processData(this.entities)
        this.makeChart(this.chartName, data)
      },
      processData (entities) {
        if (!entities || _.isEmpty(entities)) return
        let data = {
          dataProvider: [],
          graphs: []
        }

        let keys = entities.map(x => {
          if (_.isEmpty(x) || _.isEmpty(x.data)) return
          return x.data.rdvs.map(y => {
            return this.customName(y)
          })
        })
        let addEntry = function (date) {
          let entry = {date}
          keys.forEach(k => {
            if (!k || _.isEmpty(k)) return
            k.forEach(l => {
              entry[l] = 0
            })
          })
          return entry
        }

        let scale = 'YYYY-MM'
        let tmpData = {}
        let graphKeys = {}

        entities.forEach(entity => {
          if (entity && entity.data) {
            let entityData = entity.data[this.entityKey] || []
            entityData.forEach(x => {
              let name = this.customName(x)
              let entityPk = this.customName(x)

              if ((entityPk in graphKeys) === false) {
                graphKeys[entityPk] = {
                  pk: entityPk,
                  name,
                  _color: randomColor({entityPk})
                }
              }
              let date = moment(x[this.dateParam])
              date = date.format(scale)

              if (!(date in tmpData)) {
                tmpData[date] = addEntry(date, entity)
              }
              tmpData[date][name] += 1
            })
          }
        })

        let emptyDates = _.difference(this.period, Object.keys(tmpData))
        emptyDates.forEach(date => {
          tmpData[date] = addEntry(date)
        })

        tmpData = Object.values(tmpData)
        tmpData.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })
        let colors = ['#41B3EF', '#4151EF', '#301B7D', '#2e0139']
        graphKeys = _(graphKeys).toPairs().sortBy(0).fromPairs().value() // sort by RDV Type
        Object.values(graphKeys).forEach((e, i) => {
          let graph = {
            balloonText: '[[title]] : [[value]]',
            color: 'undefined',
            fillAlphas: 0.73,
            fillColors: colors[i % 4],
            lineColor: colors[i % 4],
            lineThickness: 0,
            id: e.name,
            title: e.name,
            valueField: e.name,
            type: 'column'
          }
          data.graphs.push(graph)
        })
        data.dataProvider = !_.isEmpty(graphKeys) ? tmpData : []
        return data
      },
      makeChart (container, data) {
        const chart = window.AmCharts.makeChart(container,
          {
            type: 'serial',
            categoryField: 'date',
            path: 'static/amcharts',
            color: '#CCC',
            fontFamily: 'Roboto',
            fontSize: 10,
            dataDateFormat: 'YYYY-MM',
            categoryAxis: {
              gridPosition: 'start',
              gridColor: '#CCC',
              axisColor: '#CCC'
            },
            graphs: data.graphs.slice(),
            chartCursor: {
              enabled: true,
              animationDuration: 0.30,
              cursorAlpha: 0.50,
              cursorColor: '#000'
            },
            valueAxes: [
              {
                id: 'ValueAxis-1',
                axisColor: '#CCCCCC',
                gridColor: '#F7F7F7',
                gridAlpha: 1,
                integersOnly: true
              }
            ],
            legend: {
              enabled: true,
              useGraphSettings: true
            },
            titles: [
              {
                alpha: 0,
                id: 'Title-1',
                size: 15
              }
            ],
            dataProvider: data.dataProvider.slice()
          }
        )
        window.AmCharts.checkEmptyData = function (chart) {
          if (chart.dataProvider.length === 0) {
            chart.valueAxes[0].minimum = 0
            chart.valueAxes[0].maximum = 100
            var dataPoint = {
              dummyValue: 0
            }
            dataPoint[chart.categoryField] = ''
            chart.dataProvider = [dataPoint]
            chart.addLabel(
              0,
              '50%',
              'Aucune activité n\'a été trouvée pour la période sélectionnée.\n Essayer de sélectionner une autre période. ',
              'center',
              '14',
              'black'
            )
            chart.chartDiv.style.opacity = 1
            chart.validateNow()
          }
        }
        window.AmCharts.checkEmptyData(chart)
      }
    },
    mounted () {
      this.dirtyInit()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/Charts/RdvsChart.vue